import React from "react";
import { useQuery } from "@apollo/client";
import { Row, Col } from "react-bootstrap";
import { PieChart, Pie, Cell, Legend } from "recharts";
import { GET_ACTIVE_SYSTEMS } from "../../../queries/archiveQrys/secureQrys/enfDashboardQrys";
import SkeletonLoader from "../../reuseableComponents/loaders/SkeletonLoader";
import ErrorHandler from "../../reuseableComponents/ErrorHandler";

const colors = ["#a40606", "#108c4f", "#d2b307"];

const ActiveSystems = () => {
  const { loading, error, data } = useQuery(GET_ACTIVE_SYSTEMS);
  if (loading)
    return (
      <>
        <h3>Active Systems</h3>
        <SkeletonLoader width='100%' />
      </>
    );
  if (!data)
    return (
      <>
        <h3>Active Systems</h3>
        <span>No Data Returned</span>
      </>
    );
  if (error) return <ErrorHandler error={error} />;

  const RADIAN = Math.PI / 180;
  const renderCustomLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 1.05;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
      <text x={x} y={y} fill='black' textAnchor={x > cx ? "start" : "end"} dominantBaseline='central'>
        {`${(percent * 100).toFixed(0)}%`}
      </text>
    );
  };

  return (
    <React.Fragment>
      <Row>
        <Col>
          <h3>Active Systems</h3>
        </Col>
      </Row>
      <Row>
        <Col cypressid='activeSystemsLegend'>
          <Legend
            wrapperStyle={{ position: "relative" }}
            payload={data.getActiveWaterSystemRatingsCount.map((item, index) => ({
              id: item.name,
              value: `${item.name}: ${item.value}`,
              color: colors[index % colors.length]
            }))}
            iconSize={0}
            verticalAlign='top'
            align={"left"}
            style={{ position: "relative" }}
          />
        </Col>
      </Row>
      <Row>
        <Col cypressid='activeSystemsPieChart'>
          <PieChart width={375} height={325}>
            <Pie
              data={data.getActiveWaterSystemRatingsCount}
              cx='55%'
              cy='60%'
              labelLine={false}
              label={renderCustomLabel}
              dataKey='value'
            >
              {data.getActiveWaterSystemRatingsCount.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
              ))}
            </Pie>
          </PieChart>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default ActiveSystems;
